import CryptoJS from "crypto-js";
import moment from "moment";
import { pagination } from "./Constants.config";
// import { usePermissions } from "./getPermissions";


const encryptValue = (text, secret = '123456') => {
  const secretHex = stringToHash(secret);
  const ciphertext = CryptoJS.AES.encrypt(text, secretHex).toString();
  return ciphertext;
};

const decryptValue = (ciphertext, secret = '123456') => {
  const secretHex = stringToHash(secret);
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretHex);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};

const stringToHash = secret => {
  return CryptoJS.SHA256(secret).toString();
};

const getBadgeColor = type => {
  const status = type?.toLowerCase();
  switch (status) {
    case 'ready':
    case 'active':
    case 'medium':
    case 'send':
    case 'enthusiastic':
    case 'yes':
      return 'greenBadge';
    case 'open':
      return 'greenBadge';
    case 'inactive':
    case 'at ease':
      return 'redBadge';
    case 'pending':
    case 'planned':
      return 'blueBadge';
    case 'reject':
      return 'redBadge';
    case 'rejected':
      return 'rejected';
    case 'approve':
      return 'greenBadge';
    case 'approved':
      return 'approvedgreen';
    case 'close':
    case 'unplanned':
      return 'redBadge';
    case 'accepted':
      case 'verified':
      return 'greenBadge';
    case 'draft':
    case 'tensed':
      return 'cancelledblue'
    case 'updated':
      return 'redBadge'
    case 'new':
      return 'redBadge'
    default:
      return 'blueBadge';
  }
};
const setStatusColor = (type) => {
  const status = type?.toLowerCase();
  switch (status) {
    case 'pending':
    case 'inprocess':
    case 'to do':
    case 'draft':
      return 'pendingYlw';
    case 'rejected':
    case 'reject':
    case 'inactive':
      return 'rejected';
    case 'approved':
    case 'completed':
    case 'approve':
    case 'active':
    case 'open':
    case 'submit':
    case 'saved':
    case 'send':
    case 'sent':
    case 'verify':
      return 'approvedgreen';
    case 'close':
      return 'redBadge';
    case 'accepted':
      return 'greenBadge';
    default:
      return 'cancelledblue';
  }
}
const setTextStatusColor = (type) => {
  const status = type?.toLowerCase();
  switch (status) {
    case 'pending':
    case 'inprocess':
    case 'to do':
    case 'draft':
      case 'fixed':
      return 'textBlue';
    case 'rejected':
    case 'reject':
    case 'inactive':
      
      return 'textRed';
    case 'approved':
    case 'completed':
    case 'approve':
    case 'active':
    case 'open':
    case 'submit':
    case 'saved':
    case 'send':
    case 'sent':
    case 'verify':
    case 'medium':
    case 'normal':
      
      return 'textGreen';
    case 'close':
    case 'heigh':
      return 'textRed';
    case 'accepted':
      return 'textGreen';
    default:
      return 'textBlue';
  }
}

const convertSelectObject = (label, value, data) => {
  let selectData = []
  if (typeof (key) !== 'object') {
    data?.map(data => {
      if (data?.is_active === true) {
        selectData.push({ label: data?.[label], value: data?.[value] });
      }
    });
    return selectData
  }
}
function lowerFirstLetter(string) {
  if (string !== undefined && string !== null) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const toTitleCase = (data) => {
  return data
    ?.split('_')
    ?.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(' ');
}

const transformKey = (key) => {
  const withSpaces = key.replace(/_/g, ' ');
  return withSpaces
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const dateFormate = (date, format = "DD-MM-YYYY") => {
  const momentDate = moment(date);
  if (momentDate.isValid()) {
    return momentDate.format(format);
  } else {
    return '';
  }
}
const timeFormate = (time, formate) => {
  return time ? moment(time, formate).format("HH:mm:ss") : '';
};

const timeToHourMinSec = (time) => {
  return time ? moment(time, "HH:mm").format("HH:mm:ss") : '';
};

const createShortName = (value) => {
  const short_name = value?.split(" ")?.map(word => word.charAt(0).toUpperCase()).join('')
  return short_name
}

const getCustomTableSN = (index, currentPage = 1, itemPerPage = pagination.limit) => {
  return (currentPage - 1) * itemPerPage + (index);
}

const getDataWithLabelValue = (data) => {
  const tempData = []
  if (data && data?.length > 0) {
    data?.map((item) => {
      tempData.push({ label: item, value: item })
    })
    return tempData
  }
  else {
    return tempData
  }

}
const defaultMultiSelectOptions = (data, ids) => {
  const defaultMultiOptions = data && data
    .filter(item => ids?.includes(item.value || item))
    .map(item => ({
      value: item.value || item,
      label: item.label || item
    }));
  return defaultMultiOptions
}
const checkMaxWordLimit = (text, limit) => {
  const words = text?.trim().split(/\s+/).filter(word => word?.length > 0);

  return words?.length <= limit;
};
const showingReasonWords = (text, limit) => {
  const words = text?.split(" ").slice(0, limit).join(' ')
  return words;
};

const todayDate = (format = 'YYYY-MM-DD') => {
  const date = moment().format(format);
  return date;
};

const isSameMoment = (date, type = 'day') => {
  return moment(date).isSame(moment(), type);
};
const isBeforeMoment = (date, type = 'day') => {
  return moment(date).isBefore(moment(), type);
};
const isAfterMoment = (date, type = 'day') => {
  return moment(date).isAfter(moment(), type);
};

const calculateObjectFilledPercentage = (obj) => {
  let filledCount = 0;
  const totalKeys = Object.keys(obj).length;
  if (totalKeys === 0) return 0; // Avoid division by zero
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== '' && obj[key] !== null && obj[key] !== undefined) {
      filledCount++;
    }
  }
  return Math.round((filledCount / totalKeys) * 100);
};

const calculateFilledPercentage = (data) => {
  if (Array.isArray(data)) {
    if (data.length === 0) return 0; // Handle empty array case
    const totalPercentage = data.reduce((sum, obj) => sum + calculateObjectFilledPercentage(obj), 0);
    return Math.round(totalPercentage / data.length);
  } else if (typeof data === 'object' && data !== null) {
    return calculateObjectFilledPercentage(data);
  }
  return 0; // Return 0 for invalid inputs
};

const checkAttendanceStatus = (statusType) => {
  switch (statusType) {
    case "AB":
    case "FHP":
    case "SHP":
      return "text-danger"
    case "PR":
      return "text-success"
    case "PL":
      return "text-primary"
    case "WO":
      return "text-light"
    default:
      return "text-primary"
  }
}

const setDateFormate = (date, format = 'YYYY-MM-DD') => {
  return moment(date || '').format(format);
};
const multiSelectIDs = (filterData) => {
  const Ids = []
  filterData?.map((item) => {
    Ids.push(item?.value || item?._id)
  })
  return Ids
}


const getInputPrefix = val => {
  return val === 'percentage' ? '%' : '₹';
};

const stringIds = (data) => {
  let Ids = ''
  data?.map((item) => {
    Ids += `${item.value},`
  })
  Ids = Ids.slice(0, -1);
  return Ids
}
const stringNames = (data) => {
  let name = ''
  data?.map((item) => {
    name += `${item.label},`
  })
  name = name.slice(0, -1);
  return name
}

const filterCurrentFinancialYear = (data) => {
  const today = moment().format("YYYY-MM-DD")
  const filterData = data && data?.filter((item) => item?.from < today && item?.to > today)
  return filterData?.length > 0 ? filterData[0] : {}
}

const filterCurrentFYMonth = (data) => {
  const today = moment().format("YYYY-MM")
  const filterData = data && data?.filter((item) => item?.value === today)
  return filterData?.length > 0 ? filterData[0] : {}
}

const setFilterDropdownData = (data) => {
  const updatedDropdowns = {};
  data?.forEach((item) => {
    updatedDropdowns[item?.category_short_name] = item?.dropdown_master_details;
  });
  return updatedDropdowns
}

// function greetingMsg() {
//   const hour = new Date().getHours();
//   const message = hour < 12 
//     ? "Good morning!" 
//     : hour < 18 
//     ? "Good afternoon!" 
//     : "Good evening!";

//   return message;
// }
function greetingMsg() {
  const hour = new Date().getHours();
  const messages = ["Good Morning", "Good Afternoon", "Good Evening"];
  const index = hour < 12 ? 0 : hour < 16 ? 1 : 2;

  return messages[index];
}
const getUpcomingHolidays = (data) => {
  const today = new Date();
  let upcomingHolidays = []
  if (data) {
    upcomingHolidays = data?.filter(holiday => new Date(holiday?.to_date) >= today)?.sort((a, b) => new Date(a?.to_date) - new Date(b?.to_date))
      ?.slice(0, 5);
  }


  return upcomingHolidays
}

const getPermissionRoutes = () => {
  const permissionData = sessionStorage.getItem("routePermissions");
  if (!permissionData) return [];
  try {
    const permissionRouteData = JSON.parse(permissionData);
    let allRoutes = []
    permissionRouteData.forEach((item) => {
      if (item.submenu?.length) {
        allRoutes.push(...item.submenu);
      } else {
        allRoutes.push(item);
      }
    });
    return allRoutes
  } catch (err) {
    return [];
  }

}
const isPermission = (action) => {
  const permissions = getPermissionRoutes();
  return permissions.some(item => item.route_key === action);
};

const activeTabPermission = (tabData) => {
  const visibleTabs = tabData.filter(
    (tab) => !tab.permissionId || isPermission(tab.permissionId)
  );
  
  const firstVisibleTabId = visibleTabs[0]?.id;
  return firstVisibleTabId
}

const setShortName = (name) => {
  if (name) {

    return name?.split(" ").map(word => word[0]).join('').toUpperCase()
  } else {
    return
  }
}

const downloadReport = (filePath) => {
  window.open(filePath, '_blank');
}
const downloadDirectFile = (filePath) => {
  const link = document.createElement('a');
  link.href = filePath;
  link.setAttribute('download', ''); // You can specify a filename: 'filename.txt'
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const downloadFiles = (filePath) => {
  const link = document.createElement("a");
  link.href = filePath;

  // This sets the file name (optional, uses the last part of the URL)
  link.download = filePath.split("/").pop();

  // Needed for Firefox
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const downloadTextFile = (path, fileName) => {
  const fileUrl = path;

  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


const hasSeenInitialPopups = () => {
  return localStorage.getItem('initialPopupsShown') === 'true'
};

const setInitialPopupsDone = (status = true) => {
  localStorage.setItem('initialPopupsShown', status);
};

const impactedUsers = (num) => {
  let arr = []
  for (let i = 1; i <= num; i++) {
    arr.push({ label: i, value: i })
  }
  arr.push({ label: `More Then ${num}`, value: `More Then ${num}` })
  return arr
}

const getFileIconByUrl = (url = "") => {
  const file = url.toLowerCase();

  if (file.endsWith(".pdf")) {
    return "https://cdn-icons-png.flaticon.com/512/337/337946.png"; // PDF
  } else if (file.endsWith(".doc") || file.endsWith(".docx")) {
    return "https://cdn-icons-png.flaticon.com/512/337/337932.png"; // Word
  } else if (file.endsWith(".xls") || file.endsWith(".xlsx")) {
    return "https://cdn-icons-png.flaticon.com/512/337/337959.png"; // Excel
  } else if (file.endsWith(".ppt") || file.endsWith(".pptx")) {
    return "https://cdn-icons-png.flaticon.com/512/337/337960.png"; // PowerPoint
  } else {
    return "https://cdn-icons-png.flaticon.com/512/564/564619.png"; // Generic
  }
};

const isImage = (url = "") => {
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
};

const getFileName = (url = "") => {
  return url.split("/").pop();
};

const formatEstimate = (time) => {
  if (!time || !time.includes(":")) return null;
  const [h, m] = time.split(":");
  return `${h}h:${m}m`;
};

const searchFilterData = (value, data) => {
  if (!value) return data;

  const searchValue = value.toLowerCase().trim();

  const filterData = data?.filter((item) => {
    return (
      item?.name?.toLowerCase().includes(searchValue) ||
      item?.emp_code?.toLowerCase().includes(searchValue) ||
      item?.department_name?.toLowerCase().includes(searchValue) ||
      item?.designation_name?.toLowerCase().includes(searchValue)
    );
  });

  return filterData;
};

function numberToWords(num) {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + inWords(n % 100) : "");
    if (n < 100000) return inWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + inWords(n % 1000) : "");
    if (n < 10000000) return inWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + inWords(n % 100000) : "");
    return inWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + inWords(n % 10000000) : "");
  }

  return num === 0 ? "Zero" : inWords(num);
}





export {
  encryptValue,
  decryptValue,
  getBadgeColor,
  convertSelectObject,
  toTitleCase,
  transformKey,
  calculateFilledPercentage,
  dateFormate,
  createShortName,
  getCustomTableSN,
  getDataWithLabelValue,
  defaultMultiSelectOptions,
  checkMaxWordLimit,
  timeFormate,
  timeToHourMinSec,
  setStatusColor,
  todayDate,
  isSameMoment,
  isBeforeMoment,
  isAfterMoment,
  checkAttendanceStatus,
  setDateFormate,
  multiSelectIDs,
  getInputPrefix,
  stringIds,
  filterCurrentFinancialYear,
  filterCurrentFYMonth,
  setFilterDropdownData,
  greetingMsg,
  getUpcomingHolidays,
  isPermission,
  activeTabPermission,
  setShortName,
  stringNames,
  downloadReport,
  showingReasonWords,
  hasSeenInitialPopups,
  setInitialPopupsDone,
  setTextStatusColor,
  impactedUsers,
  getFileIconByUrl,
  isImage,
  getFileName,
  downloadFiles,
  formatEstimate,
  downloadTextFile,
  searchFilterData,
  downloadDirectFile,
  numberToWords

}